"use strict";

var _taggedTemplateLiteral = require("/codebuild/output/src2429405957/src/github.com/wobicom/wobi-web-auto/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/taggedTemplateLiteral");
var _slicedToArray = require("/codebuild/output/src2429405957/src/github.com/wobicom/wobi-web-auto/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/slicedToArray");
var _templateObject;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _useMediaQuery = _interopRequireDefault(require("@material-ui/core/useMediaQuery/useMediaQuery"));
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _core = require("@material-ui/core");
var _formik = require("formik");
var yup = _interopRequireWildcard(require("yup"));
var _breakpoints = _interopRequireDefault(require("../config/breakpoints"));
var _colors = require("../config/colors.config");
var _EzFormControl = _interopRequireDefault(require("./EzFormControl"));
var _Offer = require("./Offer");
var _validation = require("./utils/validation");
var _helpers = require("./utils/helpers");
function _getRequireWildcardCache(nodeInterop) {
  if (typeof WeakMap !== "function") return null;
  var cacheBabelInterop = new WeakMap();
  var cacheNodeInterop = new WeakMap();
  return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) {
    return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
  })(nodeInterop);
}
function _interopRequireWildcard(obj, nodeInterop) {
  if (!nodeInterop && obj && obj.__esModule) {
    return obj;
  }
  if (obj === null || typeof obj !== "object" && typeof obj !== "function") {
    return {
      default: obj
    };
  }
  var cache = _getRequireWildcardCache(nodeInterop);
  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }
  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
  for (var key in obj) {
    if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }
  newObj.default = obj;
  if (cache) {
    cache.set(obj, newObj);
  }
  return newObj;
}
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
function _extends() {
  _extends = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends.apply(this, arguments);
}
var PhoneIcon = (0, _helpers.getImageByAgent)('phone2.svg');
var CarDate = (0, _helpers.getImageByAgent)('car-date.svg');
var Coffee = (0, _helpers.getImageByAgent)('coffee.svg');
var useContactUsStyle = (0, _core.makeStyles)({
  close: {
    '&.mobile': {
      '&:after, &:before': {
        height: 26,
        left: 27,
        top: 16,
        width: 3
      },
      borderRadius: 58,
      bottom: 10,
      height: 58,
      left: 'unset',
      position: 'fixed',
      right: 10,
      top: 'unset',
      width: 58
    },
    '&:after': {
      transform: 'rotate(45deg)'
    },
    '&:after, &:before': {
      backgroundColor: '#fff',
      borderRadius: 20,
      content: '""',
      height: 14,
      left: 12,
      position: 'absolute',
      top: 7,
      width: 3
    },
    '&:before': {
      transform: 'rotate(-45deg)'
    },
    '&:hover': {
      backgroundColor: _colors.Black[170]
    },
    backgroundColor: _helpers.agentDeveloperUtils.getSecondaryColor(300),
    borderRadius: 25,
    color: '#fff',
    cursor: 'pointer',
    height: 27,
    left: 6,
    padding: 5,
    position: 'absolute',
    top: 6,
    transition: '0.3s all',
    width: 27,
    zIndex: 1
  },
  details: {
    marginLeft: 15,
    width: '100%'
  },
  form: {
    '& .MuiFormControl-root': {
      width: '100%'
    },
    '&.desktop': {
      '& .MuiFormControl-root': {
        width: '100%'
      },
      '& .MuiFormLabel-root': {
        fontSize: 16,
        transform: 'translate(12px, 50%)'
      },
      '& .MuiFormLabel-root.MuiInputLabel-shrink': {
        transform: 'translate(16px, -8px) scale(0.8)'
      },
      '& .MuiOutlinedInput-input': {
        padding: '10px 12px'
      },
      '& button': {
        fontSize: 16,
        height: 39,
        padding: '5px 12px',
        width: '100%'
      },
      '& input': {
        fontSize: 16,
        fontWeight: 600
      }
    },
    '&.mobile': {},
    '&.small > div': {
      '& > div': {
        marginBottom: 6,
        marginLeft: 0,
        minWidth: '100%',
        width: '100%'
      },
      flexFloiw: 'column'
    },
    display: 'flex',
    marginTop: 20
  },
  leaveDetails: {
    color: _helpers.agentDeveloperUtils.getSecondaryColor(500),
    fontSize: 24,
    fontWeight: 500,
    lineHeight: 1,
    maxWidth: 262
  },
  popupHeader: {
    '& > div': {
      color: _helpers.agentDeveloperUtils.getSecondaryColor(300),
      fontSize: 18,
      fontWeight: 700,
      marginBottom: 30
    },
    background: 'transparent linear-gradient(180deg, #F2FCFF 0%, #FBFEFF 60%, #FFFFFF52 100%) 0% 0% no-repeat padding-box',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    padding: '42px 0 20px 0',
    textAlign: 'center',
    width: '100%'
  },
  price: {
    '& > span': {
      fontSize: 22,
      marginLeft: 10
    },
    color: _helpers.agentDeveloperUtils.getPrimaryColor(450),
    fontSize: 44,
    fontWeight: 700,
    lineHeight: 1.2
  },
  root: {
    '& .logo-wrapper': {
      '& > div': {
        color: _helpers.agentDeveloperUtils.getSecondaryColor(500),
        fontSize: 14
      },
      '& img': {
        width: '100%'
      },
      width: 157
    },
    '& .phone': {
      position: 'absolute',
      right: -10,
      top: -1,
      zIndex: 1
    },
    '&.mobile': {
      '& .details': {
        '& button': {
          height: 52,
          width: '100%'
        },
        alignItems: 'center',
        display: 'flex',
        marginLeft: 0,
        maxWidth: 240
      },
      '& .phone, & .logo-wrapper': {
        display: 'none'
      },
      '&:after': {
        display: 'none'
      },
      border: 'none',
      borderRadius: 0,
      flexDirection: 'column',
      padding: 0
    },
    '&:after': {
      backgroundColor: 'white',
      content: '" "',
      height: 36,
      pointerEvents: 'none',
      position: 'absolute',
      right: -1,
      top: -1,
      width: 30
    },
    alignItems: 'center',
    backgroundColor: '#fff',
    border: "1px solid ".concat(_helpers.agentDeveloperUtils.getPrimaryColor(450)),
    borderRadius: 20,
    display: 'flex',
    height: 'calc(100% - 50px)',
    justifyContent: 'flex-start',
    left: 20,
    overflow: 'visible',
    padding: '15px 25px 15px 15px',
    position: 'absolute',
    top: 38,
    width: 'calc(100% - 40px)',
    zIndex: 1
  },
  thankYou: {
    '& .items': {
      '& > div': {
        '&:before': {
          backgroundColor: _helpers.agentDeveloperUtils.getSecondaryColor(100),
          borderRadius: 10,
          content: '""',
          height: 10,
          left: 0,
          position: 'absolute',
          top: 6,
          width: 10
        },
        marginBottom: 20,
        paddingLeft: 30,
        position: 'relative'
      },
      '& span': {
        display: 'block',
        fontSize: 14,
        fontWeight: 700,
        marginBottom: 10
      },
      color: _colors.Black[280],
      fontSize: 12,
      padding: '0 70px',
      paddingBottom: 80
    },
    '& .thanks-header': {
      '& .title1': {
        color: _helpers.agentDeveloperUtils.getSecondaryColor(300),
        fontSize: 26,
        fontWeight: 700,
        marginTop: 20
      },
      '& .title2': {
        color: _colors.Black[300],
        fontSize: 16
      },
      '& > div': {
        textAlign: 'center'
      },
      '& img': {
        width: 104
      },
      '&:after': {
        bottom: 0,
        color: _helpers.agentDeveloperUtils.getSecondaryColor(100),
        content: "\"".concat('•'.repeat(200), "\""),
        display: 'block',
        fontSize: 12,
        height: 10,
        letterSpacing: 2,
        lineHeight: 1,
        overflow: 'hidden',
        position: 'absolute',
        width: 'calc(100% - 60px)'
      },
      alignItems: 'center',
      background: 'transparent linear-gradient(180deg, #F2FCFF 0%, #FBFEFF 60%, #FFFFFF52 100%) 0% 0% no-repeat padding-box',
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center',
      marginBottom: 30,
      padding: '57px 0 50px 0',
      position: 'relative'
    },
    '&.desktop': {
      '& .items': {
        '& > div:last-child': {
          marginBottom: 0
        },
        paddingBottom: 0,
        paddingRight: 0
      },
      '& .thanks-header': {
        '& .title1': {
          lineHeight: 1,
          marginBottom: 10,
          marginTop: 0
        },
        '& > div': {
          textAlign: 'left'
        },
        '& img': {
          display: 'none'
        },
        '&:after': {
          display: 'none'
        },
        background: 'unset',
        flexDirection: 'row',
        justifyContent: 'flex-start',
        marginBottom: 0,
        minWidth: 161,
        padding: 0
      },
      alignItems: 'center',
      backgroundColor: '#fff',
      display: 'flex',
      height: '100%',
      left: 0,
      overflow: 'auto',
      padding: 30,
      position: 'absolute',
      top: 0,
      width: '100%'
    }
  }
});
var OfferIntegratedContactUs = function OfferIntegratedContactUs(_ref) {
  var showContactUs = _ref.showContactUs,
    data = _ref.data,
    contactUsSubmitHandler = _ref.contactUsSubmitHandler,
    closeContactUsHandler = _ref.closeContactUsHandler;
  var classes = useContactUsStyle();
  var logo = data.logo,
    price = data.price,
    productLineName = data.productLineName;
  var isMobile = (0, _useMediaQuery.default)("(max-width:".concat(_breakpoints.default.mobile, "px)"));
  var isDownSB = (0, _useMediaQuery.default)('(max-width:788px)');
  var _react$default$useSta = _react.default.useState(false),
    _react$default$useSta2 = _slicedToArray(_react$default$useSta, 2),
    showThankYou = _react$default$useSta2[0],
    setShowThankYou = _react$default$useSta2[1];
  var Transition = /*#__PURE__*/_react.default.forwardRef(function (props, ref) {
    return /*#__PURE__*/_react.default.createElement(_core.Slide, _extends({
      direction: "up",
      ref: ref
    }, props));
  });
  var From = /*#__PURE__*/_react.default.createElement("div", {
    className: "".concat(classes.root, " ").concat(isMobile ? 'mobile' : '')
  }, isMobile ? /*#__PURE__*/_react.default.createElement("div", {
    className: classes.popupHeader
  }, /*#__PURE__*/_react.default.createElement("div", null, "\u05D4\u05E9\u05D0\u05D9\u05E8\u05D5 \u05E4\u05E8\u05D8\u05D9\u05DD \u05D5\u05E0\u05D7\u05D6\u05D5\u05E8 \u05D0\u05DC\u05D9\u05DB\u05DD \u05D1\u05D4\u05E7\u05D3\u05DD"), /*#__PURE__*/_react.default.createElement("img", {
    src: CarDate,
    alt: ""
  })) : false, /*#__PURE__*/_react.default.createElement("img", {
    src: PhoneIcon,
    alt: "phone",
    className: "phone"
  }), /*#__PURE__*/_react.default.createElement(_Offer.Close, {
    className: "".concat(classes.close, " ").concat(isMobile ? 'mobile' : ''),
    onClick: closeContactUsHandler
  }), /*#__PURE__*/_react.default.createElement("div", {
    className: "logo-wrapper"
  }, /*#__PURE__*/_react.default.createElement("img", {
    src: logo,
    alt: "logo"
  }), /*#__PURE__*/_react.default.createElement("div", null, productLineName)), /*#__PURE__*/_react.default.createElement("div", {
    className: "".concat(classes.details, " details")
  }, isMobile ? false : /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("div", {
    className: classes.price
  }, /*#__PURE__*/_react.default.createElement("span", null, "\u20AA"), price.toLocaleString()), /*#__PURE__*/_react.default.createElement("div", {
    className: classes.leaveDetails
  }, "\u05D4\u05E9\u05D0\u05D9\u05E8\u05D5 \u05E4\u05E8\u05D8\u05D9\u05DD \u05D5\u05E0\u05D7\u05D6\u05D5\u05E8 \u05D0\u05DC\u05D9\u05DB\u05DD \u05D1\u05D4\u05E7\u05D3\u05DD")), /*#__PURE__*/_react.default.createElement("div", {
    className: "".concat(classes.form, " ").concat(isMobile ? 'mobile' : 'desktop', " ").concat(isDownSB ? 'small' : 'normal')
  }, /*#__PURE__*/_react.default.createElement(_formik.Formik, {
    onSubmit: function onSubmit(values) {
      console.log(contactUsSubmitHandler);
      contactUsSubmitHandler(values).then(function () {
        setShowThankYou(true);
      });
    },
    validationSchema: yup.object().shape({
      name: _validation.hebrewOnly,
      phone: _validation.validPhone
    }),
    initialValues: {
      name: '',
      phone: ''
    }
  }, function (_ref2) {
    var values = _ref2.values,
      handleChange = _ref2.handleChange,
      handleSubmit = _ref2.handleSubmit;
    return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(PopupFormRow, null, /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement(_EzFormControl.default, {
      name: "name",
      label: 'שם מלא',
      isLabelInChild: true
    }, /*#__PURE__*/_react.default.createElement(_core.TextField, {
      onChange: handleChange
    }))), /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement(_EzFormControl.default, {
      name: "phone",
      label: 'טלפון',
      isLabelInChild: true
    }, /*#__PURE__*/_react.default.createElement(_core.TextField, {
      inputProps: {
        maxLength: 10
      },
      onChange: handleChange
    }))), /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement(_core.Button, {
      onClick: function onClick() {
        return handleSubmit(values.name, values.phone);
      },
      variant: "outlined"
    }, "\u05D4\u05EA\u05E7\u05E9\u05E8\u05D5 \u05D0\u05DC\u05D9"))));
  }))));
  var ThankYou = /*#__PURE__*/_react.default.createElement("div", {
    className: "".concat(classes.thankYou, " ").concat(isMobile ? 'mobile' : 'desktop')
  }, /*#__PURE__*/_react.default.createElement(_Offer.Close, {
    className: "".concat(classes.close, " ").concat(isMobile ? 'mobile' : ''),
    onClick: closeContactUsHandler
  }), /*#__PURE__*/_react.default.createElement("div", {
    className: "thanks-header"
  }, /*#__PURE__*/_react.default.createElement("img", {
    src: Coffee,
    alt: "coffee"
  }), /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement("div", {
    className: "title1"
  }, "\u05E4\u05E0\u05D9\u05D9\u05EA\u05DA \u05D4\u05EA\u05E7\u05D1\u05DC\u05D4"), /*#__PURE__*/_react.default.createElement("div", {
    className: "title2"
  }, "\u05E0\u05E6\u05D9\u05D2 \u05DE\u05DB\u05D9\u05E8\u05D5\u05EA \u05D9\u05D7\u05D6\u05D5\u05E8 \u05D0\u05DC\u05D9\u05DA \u05D1\u05D4\u05E7\u05D3\u05DD"))), /*#__PURE__*/_react.default.createElement("div", {
    className: "items"
  }, /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement("span", null, "\u05DC\u05E7\u05D5\u05D7\u05D5\u05EA Wobi \u05E0\u05D4\u05E0\u05D9\u05DD \u05D9\u05D5\u05EA\u05E8!"), "\u05E0\u05E6\u05D9\u05D2\u05D9\u05E0\u05D5 \u05D9\u05E9\u05DE\u05D7\u05D5 \u05DC\u05E1\u05D9\u05D9\u05E2 \u05DC\u05DB\u05DD \u05D1\u05D8\u05DC\u05E4\u05D5\u05DF \u05D1\u05E8\u05DB\u05D9\u05E9\u05EA \u05D1\u05D9\u05D8\u05D5\u05D7 \u05DE\u05E9\u05EA\u05DC\u05DD \u05D5\u05DE\u05D5\u05EA\u05D0\u05DD \u05E2\u05D1\u05D5\u05E8\u05DB\u05DD"), /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement("span", null, "\u05DE\u05DC\u05D5\u05D5\u05D9\u05DD \u05D0\u05D5\u05EA\u05DA \u05DB\u05DC \u05D4\u05D3\u05E8\u05DA"), "\u05DE\u05D1\u05D5\u05D8\u05D7\u05D9 Wobi \u05E0\u05D4\u05E0\u05D9\u05DD \u05DE\u05E9\u05D9\u05E8\u05D5\u05EA \u05E4\u05E8\u05DE\u05D9\u05D5\u05DD \u05DC\u05DB\u05DC \u05D0\u05D5\u05E8\u05DA \u05D4\u05D3\u05E8\u05DA, \u05D4\u05E0\u05D9\u05EA\u05DF \u05E2\u05DC \u05D9\u05D3\u05D9 \u05E0\u05E6\u05D9\u05D2\u05D9\u05DD \u05DE\u05D9\u05D5\u05DE\u05E0\u05D9\u05DD \u05D5\u05DE\u05E7\u05E6\u05D5\u05E2\u05D9\u05D9\u05DD")));
  if (showContactUs) {
    return isMobile ? /*#__PURE__*/_react.default.createElement(_core.Dialog, {
      fullScreen: true,
      open: showContactUs,
      TransitionComponent: Transition
    }, showThankYou ? ThankYou : From) : /*#__PURE__*/_react.default.createElement(_core.Grow, {
      in: showContactUs
    }, showThankYou ? ThankYou : From);
  }
  return null;
};
var PopupFormRow = _styledComponents.default.div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  max-width: 600px;\n  width: 100%;\n  display: flex;\n  flex-wrap: wrap;\n  box-sizing: border-box;\n  > div {\n    flex: 0 0 auto;\n    width: calc(33.33% - 7px);\n    min-width: 105px;\n    margin-left: 10px;\n    :last-child { margin-left: 0; }\n  }\n  .MuiFormHelperText-contained {\n    margin: 3px 12px;\n  }\n"])));
OfferIntegratedContactUs.propTypes = {
  closeContactUsHandler: _propTypes.default.func,
  contactUsSubmitHandler: _propTypes.default.func,
  data: _propTypes.default.object,
  showContactUs: _propTypes.default.func
};
var _default = exports.default = OfferIntegratedContactUs;